import React from 'react';
import { useResearchContext } from '@/finsight/application/Research/ResearchContext';
import Paginator from '@dealroadshow/uikit/core/components/Paginator';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

const PaginatorContainer = (props) => {
  const {
    paginate,
    getResearchList,
    researchData: {
      totalCount,
      perPage,
      page,
    },
  } = useResearchContext();
  const onPageChange = ({ selected }) => {
    paginate(selected);
    getResearchList({ page: selected });
  };

  return (
    <Paginator
      onPageChange={ onPageChange }
      totalCount={ totalCount }
      perPage={ perPage }
      page={ page }
      isItemsPerPageVisible={ false }
      className={ spacesStyles.pl }
      { ...props }
    />
  );
};

export default PaginatorContainer;
